// import

import {
  faFacebookF as Facebook,
  faGetPocket as Pocket,
  faGoodreadsG as Goodreads,
  faInstagram as Instagram,
  faLinkedinIn as LinkedIn,
  faPinterest as Pinterest,
  faRedditAlien as Reddit,
  faTumblr as Tumblr,
  faTwitter as Twitter,
  faWordpressSimple as Wordpress,
  faYoutube as YouTube,
} from '@fortawesome/free-brands-svg-icons';
import {MailIcon as Email} from '@heroicons/react/outline';

import {FontAwesome} from './FontAwesome';

// types

type Props = {
  size?: number | string;
  title?: string;
  icon: keyof typeof socialIcons;
};

// vars

export const socialIcons = {
  facebook: Facebook,
  goodreads: Goodreads,
  instagram: Instagram,
  linkedin: LinkedIn,
  pinterest: Pinterest,
  pocket: Pocket,
  reddit: Reddit,
  tumblr: Tumblr,
  twitter: Twitter,
  wordpress: Wordpress,
  youtube: YouTube,
  email: Email,
};

// component

export function SocialIcon(props: Props) {
  const {icon, size, ...rest} = props;

  return icon === 'email' ? (
    <Email {...rest} height={size} width={size} />
  ) : (
    <FontAwesome {...rest} icon={socialIcons[icon]} />
  );
}
